var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAssignmentFilled = function SvgAssignmentFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M10.081 1.25a1.75 1.75 0 0 0-1.366.656L7.64 3.25H6A2.75 2.75 0 0 0 3.25 6v13A2.75 2.75 0 0 0 6 21.75h12A2.75 2.75 0 0 0 20.75 19V6A2.75 2.75 0 0 0 18 3.25h-1.64l-1.073-1.343v-.001a1.75 1.75 0 0 0-1.367-.656h-3.839ZM9 5.25A.25.25 0 0 1 8.75 5h-1.5c0 .966.784 1.75 1.75 1.75h6A1.75 1.75 0 0 0 16.75 5h-1.5a.25.25 0 0 1-.25.25H9Zm-1 5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Zm0 5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAssignmentFilled);
export default ForwardRef;